/**
 * Default '' = same origin. In `npm start`, CRA proxies `/api` → backend (see setupProxy.js).
 * Set REACT_APP_API_BASE_URL only if the API is on another origin (e.g. phone testing).
 */
const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

// Helper function to get auth headers
export const getAuthHeaders = async (getToken) => {
  const token = await getToken();
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

// Helper function for authenticated fetch
export const authenticatedFetch = async (url, options = {}, getToken) => {
  const token = await getToken();
  const headers = {
    'Authorization': `Bearer ${token}`,
    ...options.headers
  };

  const prefix = API_BASE_URL || '';
  const path = url.startsWith('/') ? url : `/${url}`;
  return fetch(`${prefix}${path}`, {
    ...options,
    headers
  });
};

export { API_BASE_URL };

